import {
    BOND_HEADER_ACTIONS,
    BOND_DETAIL_ACTIONS,
    BOND_PRICE_ACTIONS,
    BOND_ANALYTICS_ACTIONS,
    BOND_DETAIL_TOKEN_ACTIONS,
    SAME_ISSUER_BONDS_ACTIONS,
  } from "../../actionType/bondDetails";
  
  const intialState = {
    bondsHeaderDetail: [],
    isBondsHeaderDetailLoader: false,
    bondsAnalyticsDetail: [],
    isBondsAnalyticsDetailLoader: false,
    bondsDetailData: [],
    isBondsDetailDataLoader: false,
    bondsDetailTokenData: {},
    isBondsDetailTokenLoader: false,
    isSameIssuerBondsLoader: false,
    sameIssuerBondsData: [],
  };
  
  export const bondsDetailReducer = (
    state = intialState,
    { type, payload }: any
  ) => {
    switch (type) {
      case BOND_HEADER_ACTIONS.BOND_HEADER_REQUEST:
        return { ...state, isBondsHeaderDetailLoader: true };
      case BOND_HEADER_ACTIONS.BOND_HEADER_RESPONSE:
        return {
          ...state,
          bondsHeaderDetail: payload,
          isBondsHeaderDetailLoader: false,
        };
      case BOND_HEADER_ACTIONS.BOND_HEADER_ERROR:
        return {
          ...state,
          bondsHeaderDetail: payload,
          isBondsHeaderDetailLoader: false,
        };
  
      // BOND_ANALYTICS_ACTIONS
      case BOND_ANALYTICS_ACTIONS.BOND_ANALYTICS_REQUEST:
        return { ...state, isBondsAnalyticsDetailLoader: true };
      case BOND_ANALYTICS_ACTIONS.BOND_ANALYTICS_RESPONSE:
        return {
          ...state,
          bondsAnalyticsDetail: payload,
          isBondsAnalyticsDetailLoader: false,
        };
      case BOND_ANALYTICS_ACTIONS.BOND_ANALYTICS_ERROR:
        return {
          ...state,
          bondsAnalyticsDetail: payload,
          isBondsAnalyticsDetailLoader: false,
        };
      // BOND_PRICE_GRAPH_ACTIONS
      case BOND_PRICE_ACTIONS.GET_BOND_PRICE_CHARTS_REQUEST:
        return { ...state, isbondPriceChartsDataLoader: true };
      case BOND_PRICE_ACTIONS.GET_BOND_PRICE_CHARTS_RESPONSE:
        return {
          ...state,
          bondPriceChartsData: payload,
          isbondPriceChartsDataLoader: false,
        };
      case BOND_PRICE_ACTIONS.GET_BOND_PRICE_CHARTS_ERROR:
        return {
          ...state,
          bondPriceChartsData: payload,
          isbondPriceChartsDataLoader: false,
        };
      // BOND_DETAIL_ACTIONS
      case BOND_DETAIL_ACTIONS.BOND_DETAIL_REQUEST:
        return { ...state, isBondsDetailDataLoader: true };
      case BOND_DETAIL_ACTIONS.BOND_DETAIL_RESPONSE:
        return {
          ...state,
          bondsDetailData: payload,
          isBondsDetailDataLoader: false,
        };
      case BOND_DETAIL_ACTIONS.BOND_DETAIL_ERROR:
        return {
          ...state,
          bondsDetailData: payload,
          isBondsDetailDataLoader: false,
        };
  
      // BOND_DETAIL_TOKEN_ACTIONS
      case BOND_DETAIL_TOKEN_ACTIONS.BOND_DETAIL_TOKEN_REQUEST:
        return { ...state, isBondsDetailTokenLoader: true };
      case BOND_DETAIL_TOKEN_ACTIONS.BOND_DETAIL_TOKEN_RESPONSE:
        return {
          ...state,
          bondsDetailTokenData: payload,
          isBondsDetailTokenLoader: false,
        };
      case BOND_DETAIL_TOKEN_ACTIONS.BOND_DETAIL_TOKEN_ERROR:
        return {
          ...state,
          bondsDetailTokenData: payload,
          isBondsDetailTokenLoader: false,
        };
  
      // SAME_ISSUER_BONDS_ACTIONS
      case SAME_ISSUER_BONDS_ACTIONS.SAME_ISSUER_BONDS_REQUEST:
        return { ...state, isSameIssuerBondsLoader: false };
      case SAME_ISSUER_BONDS_ACTIONS.SAME_ISSUER_BONDS_RESPONSE:
        return {
          ...state,
          sameIssuerBondsData: payload,
          isSameIssuerBondsLoader: true,
        };
      case SAME_ISSUER_BONDS_ACTIONS.SAME_ISSUER_BONDS_ERROR:
        return {
          ...state,
          sameIssuerBondsData: payload,
          isSameIssuerBondsLoader: false,
        };
  
      default:
        return state;
    }
  };
  